var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 158,
    viewBox: "0 0 158 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.805 62.0952C147.628 94.231 150.448 122.219 118.474 130.786C101.659 135.291 62.9281 137.384 39.3686 124.572C16.6 118.338 13.6179 90.9455 9.73655 76.196C1.54977 45.0856 35.452 31.0085 67.4259 22.4411C99.3998 13.8737 136.619 30.9848 144.805 62.0952Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2764 18C79.8141 18.1043 71.7391 20.3144 67.137 28.3209C62.5348 36.3274 30.1708 90.7675 14.564 116.987C9.23748 124.962 4.17727 140.725 26.5487 139.974C48.9202 139.224 108.631 138.932 135.69 138.879C143.04 137.837 155.632 131.999 147.195 116.987C138.758 101.974 106.394 48.0765 91.2662 23.0041M134.411 122.46L79.9206 31.2921L26.5487 124.962L124.608 126.444",
    stroke: "#3D3935",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3 101C78.6732 87.4832 71.5018 60.1668 79.8299 59.0352C88.1581 57.9036 86.2881 84.3398 84.3121 97.6994",
    stroke: "#EF533F",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4636 110.843C80.2296 109.88 82.3047 108.241 84.4774 109.398C87.1932 110.843 87.4021 113.734 86.5664 115.18C85.7308 116.625 82.3883 117.864 80.5081 116.212C79.004 114.89 78.9065 112.908 79.0458 112.082",
    stroke: "#EF533F",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H158V158H0V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.54444e5482ede26e55b38ab9b1ff9caa.svg";
export { ForwardRef as ReactComponent };